<div class="layout-container" [ngClass]="containerClass">
  <app-sidebar *ngIf="!isStandalonePage"></app-sidebar>
  <div class="layout-content-wrapper">
    <app-topbar *ngIf="!isStandalonePage"></app-topbar>
    <app-breadcrumb
      *ngIf="!isStandalonePage"
      class="content-breadcrumb"
    ></app-breadcrumb>
    <div class="layout-content">
      <router-outlet></router-outlet>
    </div>
  </div>
  <app-profilemenu *ngIf="!isStandalonePage"></app-profilemenu>
  <div class="layout-mask" *ngIf="!isStandalonePage"></div>
</div>
